import { doc, collection, setDoc } from "firebase/firestore";
import { useState } from "react";
import { db } from "./firebaseconfig";
import { Link } from "react-router-dom";

function AddRedirect(props) {
  const [newShort, setNewShort] = useState(props.id || "");

  const addRedirect = async (e) => {
    e.preventDefault();
    const short = e.target[0].value.toLowerCase();
    const url = e.target[1].value;

    try {
      const newDocRef = doc(collection(db, "urls"), short);
      const newTrackingRef = doc(collection(db, "tracking"), short);

      await setDoc(newTrackingRef, {
        visits: [],
      });
      await setDoc(newDocRef, {
        url,
        created: new Date().toISOString(),
      });
      window.location.reload();
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <div id="add-outer-container">
      <div id="add-inner-container">
        <h1 style={{ fontSize: "1.8rem", color: "#333" }}>
          New Redirect{" "}
          <Link
            style={{
              fontSize: "1.3rem",
              color: "gray",
              textDecoration: "none",
            }}
            to="/"
          >
            ⓧ
          </Link>
        </h1>
        <form id="add-redirect-form" onSubmit={(e) => addRedirect(e)}>
          {props.id ? (
            <input
              placeholder="Identifier"
              className="input-box"
              type="text"
              defaultValue={props.id.toLowerCase()}
              onChange={(e) => setNewShort(e.target.value)}
            ></input>
          ) : (
            <input
              placeholder="Identifier"
              className="input-box"
              type="text"
              onChange={(e) => setNewShort(e.target.value)}
            ></input>
          )}
          <input
            style={{ marginBottom: "0" }}
            placeholder="URL (starts with https://)"
            className="input-box"
            type="text"
          ></input>
          <p>
            New URL:{" "}
            <b>
              {window.location.origin}/{newShort}
            </b>
          </p>
          <button
            style={{ marginTop: "1rem" }}
            type="submit"
            className="add-redirect-btn"
          >
            Add
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddRedirect;
